import { NgModule } from '@angular/core';
import { environment } from '@et/environment';
import { getDocPrepServiceDomain } from '@et/utils';
import {
  v2ProfileApiModule,
  Configuration,
  ConfigurationParameters,
} from '@escrowtab/v2profile-api-client';
import {
  packetsApiModule,
  Configuration as PacketsConfiguration,
  ConfigurationParameters as PacketsConfigurationParameters,
} from '@escrowtab/packets-api-client';
import {
  docprepApiModule,
  Configuration as DocPrepConfiguration,
  ConfigurationParameters as DocPrepConfigurationParameters,
} from '@escrowtab/docprep-api-client';

function profileConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    basePath: environment.profilev2.domain,
  };
  return new Configuration(params);
}

function packetsConfigFactory(): PacketsConfiguration {
  const params: PacketsConfigurationParameters = {
    basePath: environment.packetService.domain,
  };
  return new PacketsConfiguration(params);
}

function docPrepConfigFactory(): DocPrepConfiguration {
  const params: DocPrepConfigurationParameters = {
    basePath: getDocPrepServiceDomain(),
  };
  return new DocPrepConfiguration(params);
}

@NgModule({
  imports: [
    v2ProfileApiModule.forRoot(profileConfigFactory),
    packetsApiModule.forRoot(packetsConfigFactory),
    docprepApiModule.forRoot(docPrepConfigFactory),
  ],
  exports: [v2ProfileApiModule, packetsApiModule, docprepApiModule],
})
export class AppApiModule {}
